import { useEffect, useState } from "react";
import { exportSalesPdf } from "../../lib/exportSalesPDF";
import SalesFilters from "../../components/SalesFilter";
import SalesTable from "../../components/SalesTable";
import { RoleBasedLayout } from "../../components/RoleBasedLayout";
import { RefreshCcw, Upload } from "lucide-react";
import { fetchSalesHistory, updateHistoryFilters, type SalesHistoryFilters } from "../../slices/salesSlice";
import { useSales } from "../../hooks/useSales";
import { useAppDispatch } from "../../hooks";
import RecentSalesSkeleton from "../../components/RecentSalesTableSkeleton";


const SalesHistoryPage: React.FC = () => {
    const { history, loading } = useSales();
    const dispatch = useAppDispatch();

    const [filters, setFilters] = useState<SalesHistoryFilters>({
        storeId: null,
        productId: null,
        startDate: null,
        endDate: null
    });

    const handleFilterChange = (partials: Partial<SalesHistoryFilters>) => {
        setFilters((prev) => ({
            ...prev,
            ...partials
        }));
    };

    useEffect(() => {
        console.log("Filters: ", filters);
        dispatch(updateHistoryFilters(filters));
        dispatch(fetchSalesHistory());
    }, [filters])

    return (
        <RoleBasedLayout>
            <div className="p-4 space-y-6">
                <div className="flex flex-col md:flex-row md:justify-end gap-3">
                    <button
                        onClick={() => exportSalesPdf(history)}
                        className="flex items-center gap-2 px-4 py-4 rounded-md bg-primary hover:bg-blue-900 text-white"
                    >
                        <Upload />
                        Export to PDF
                    </button>
                    <button
                        onClick={() => dispatch(fetchSalesHistory())}
                        className="flex items-center gap-2 px-4 py-4 rounded-md border border-gray-600 text-gray-700 hover:border-gray-900"
                    >
                        <RefreshCcw />
                        Refresh
                    </button>
                </div>

                <SalesFilters onFilterChange={handleFilterChange} />

                {
                    loading ? (
                        <RecentSalesSkeleton />
                    ) : (
                        <SalesTable sales={history} />
                    )
                }
            </div>
        </RoleBasedLayout>
    );
};

export default SalesHistoryPage;
